import React from "react";
import Text from "../typography/text.js";
import "./styles.css";

// The generic boxed section container. common/card is a fixed-shape KPI card
// (top bar, one big value, an "Across N …" footer) and cannot hold arbitrary
// content, so pages that need a titled region of any size use this instead.
// It borrows Card's surface tokens — the same radius and blue-tinted shadow —
// so a Panel and a Card sitting next to each other read as one family.
//
// title:    section heading, rendered at the h2 step so there is a real size
//           jump between a page title, a section title and body copy.
// meta:     supporting text pinned to the right of the heading.
// actions:  controls pinned to the right of the heading (tab switchers etc).
// A panel with neither title nor actions renders no header row at all.
const Panel = ({
  title,
  meta,
  actions,
  children,
  className = "",
  contentClassName = "",
  as: Tag = "section",
  ...rest
}) => {
  const hasHeader = Boolean(title || meta || actions);

  return (
    <Tag className={`panel ${className}`} {...rest}>
      {hasHeader && (
        <div className="panel-header">
          {title && <Text variant="h2">{title}</Text>}
          {(actions || meta) && (
            <div className="panel-header-end">
              {meta && (
                <Text variant="tinyText" color="lightText">
                  {meta}
                </Text>
              )}
              {actions && <div className="panel-actions">{actions}</div>}
            </div>
          )}
        </div>
      )}
      <div className={`panel-content ${contentClassName}`}>{children}</div>
    </Tag>
  );
};

export default Panel;
